'use strict';

function SetPassword($http, $location, $timeout) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.isValidRepeat = _isValidRepeat;
  vm.isValidLength = _isValidLength;
  vm.canSetPassword = _canSetPassword;
  vm.submit = _submit;

  function $onInit() {}

  function _submit() {
    var token = $location.search()['token'];
    var url = vm.invite ? 'accept_invite/' : 'set_password/';
    $http.post(url, {token: token, password : vm.password}).success(function() {
      vm.displaySuccess = true;
      $timeout(function() {
        $location.path('/login');
      }, 10000);
    });
  }

  function _isValidRepeat() {
    if (!vm.passwordRepeat) {
      return true;
    }
    return vm.passwordRepeat === vm.password;
  }

  function _isValidLength() {
    if (vm.password) {
      return vm.password.length >= 8;
    }
    return false;
  }

  function _canSetPassword() {
    if (vm.passwordRepeat === vm.password && vm.isValidLength()) {
      return true;
    }
    return false;
  }
}

module.exports = SetPassword;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/set-password/set-password.controller.js
 ** module id = 181
 ** module chunks = 0
 **/